import React, {useEffect, useState} from 'react';

import {getCompanies, getServices} from '../api';
import {unauthorized} from '../utils';
import {Header, Navbar} from '.';

const PageContainer = ({children, role, companyName, title, history}) => {
  const [menu, setMenu] = useState();
  const [loading, setLoading] = useState(true);

  const handleData = async () => {
    if (role === 'CUSTOMER') {
      const servicesData = await getServices();
      await unauthorized(servicesData.error, history);

      setMenu(servicesData);
    } else {
      const companiesData = await getCompanies();
      await unauthorized(companiesData.error, history);

      setMenu(companiesData);
    }
    setLoading(false);
  };

  useEffect(() => {
    handleData();
  }, []);

  if (loading) return <p>loading</p>;

  return (
    <div className="home-container">
      <Navbar role={role} companyName={companyName} menu={menu} />
      <div>
        <Header title={title} />
        <div className="page-container">{children}</div>
      </div>
    </div>
  );
};

export default PageContainer;
